import { render, staticRenderFns } from "./SearchOptionsHeader.vue?vue&type=template&id=5474ecbc&scoped=true&"
import script from "./SearchOptionsHeader.vue?vue&type=script&lang=js&"
export * from "./SearchOptionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchOptionsHeader.vue?vue&type=style&index=0&id=5474ecbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474ecbc",
  null
  
)

export default component.exports